import { DrawerProductItem } from '../types/ppg-sku-drawer.model';
import {
  IOpportunityPayload,
  SubmitOpportunityPayload
} from '../types/opportunity.model';

function isArrayDifferent(arr1: number[], arr2: number[]) {
  if (arr1.length !== arr2.length) {
    return true;
  }
  return arr1.some((val) => !arr2.includes(val));
}

/**
 * Determines if the initial opportunities and selected opportunities are different
 * @param initialParentOpportunities Initial opportunities that were selected when drawer loaded
 * @param initialChildOpportunities Initial opportunities of child that were selected when drawer loaded
 * @param selectedParentOpportunities Selection of opportunities for parent made by the user
 * @param selectedChildOpportunities Selection of opportunities for child made by the user
 * @returns boolean indicating whether there is difference in selection
 */
export function isOpportunitySelectionChanged(
  initialParentOpportunities: number[],
  initialChildOpportunities: number[][],
  selectedParentOpportunities: number[],
  selectedChildOpportunities: number[][]
) {
  if (initialChildOpportunities.length !== selectedChildOpportunities.length) {
    return true;
  }
  if (
    isArrayDifferent(initialParentOpportunities, selectedParentOpportunities)
  ) {
    return true;
  }
  if (
    selectedChildOpportunities.some((selectedChildOpportunity, index) => {
      const initialChildOpportunity = initialChildOpportunities[index];
      return isArrayDifferent(
        selectedChildOpportunity,
        initialChildOpportunity
      );
    })
  ) {
    return true;
  }
  return false;
}

/**
 * Creates payload for the drawer submit API
 * @param product The details of product displayed on the drawer and selected opportunities
 * @param parentId ID of the PPG
 * @returns Payload for drawer submit API
 */
export function createDrawerAPIPayload(
  parentItem: { opportunities: number[]; id: number },
  parentId: number,
  childItems: { opportunities: number[]; id: number }[],
  isParentPPG: boolean
): IOpportunityPayload[] {
  return [
    {
      ppg_id: parentId,
      sku_id: isParentPPG ? -1 : parentItem.id,
      selected_opportunities: parentItem.opportunities.slice()
    },
    ...childItems.map<IOpportunityPayload>((childDetails) => ({
      ppg_id: parentId,
      sku_id: childDetails.id,
      selected_opportunities: childDetails.opportunities.slice()
    }))
  ];
}

export function createPayloadForOpportunitySubmissionV2(
  drawerData: DrawerProductItem[],
  levelMapping: string[]
): { prod_details: { [key: string]: string }[] } {
  const selectedOpportunityMapping = [];
  const getSelectedOpportunityData = (
    parentDrawerData: DrawerProductItem[]
  ) => {
    // eslint-disable-next-line array-callback-return
    parentDrawerData.forEach((data: DrawerProductItem) => {
      
        let productLevelMappingData = {};
        levelMapping.forEach((drawerLevel) => {
          productLevelMappingData = Object.assign(productLevelMappingData, {
            [drawerLevel]:
              data.parent.data[drawerLevel] !== 'NAN'
                ? data.parent.data[drawerLevel]
                : -1
          });
        });
        selectedOpportunityMapping.push({
          ...productLevelMappingData,
          selected_opportunities: data.parent.data.selected_opportunity
        });
      
      if (data.children.length) {
        getSelectedOpportunityData(data.children);
      }
      // return selectedOpportunityMapping;
    });
  };
  getSelectedOpportunityData(drawerData);
  return {
    prod_details: selectedOpportunityMapping
  };
}
